import { useEffect } from 'react';
import { CustomRoutes } from 'react-admin';
import { Route, useNavigate } from 'react-router';
import AppSelector from '../components/AppSelector';
import { NonPermission } from '../components/NonPermission';
import { UserManagement } from '../components/UserManagement';
import PageLogin from '../resources/auth/PageLogin';
import PageReset from '../resources/auth/PageReset';
import { hasRole } from '../utils/roles';

export const PublicRoutes = {
  RECOVER: 'recuperar-password',
  RESET: 'reset-password',
};

// Componente que envuelve el Dashboard y maneja la lógica de redirección
const DashboardWrapper = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Solo ejecutar si el usuario está autenticado (tiene token)
    const token = localStorage.getItem('token');
    if (!token) {
      // Si no está autenticado, no hacer nada - React Admin manejará la redirección al login
      return;
    }

    const currentApp = localStorage.getItem('currentApp') || 'card';
    const hasSelectedApp = localStorage.getItem('appSelected') === 'true';

    // Si no ha seleccionado aplicación, redirigir al selector
    if (!hasSelectedApp) {
      navigate('/app-selector', { replace: true });
      return;
    }

    // Si la aplicación actual es quality, redirigir a /quality
    if (currentApp === 'quality') {
      navigate('/quality', { replace: true });
      return;
    }

    // Si es card y ya seleccionó, mostrar el dashboard (no hacer nada)
  }, [navigate]);

  // Importar Dashboard aquí para evitar importaciones circulares
  const Dashboard = require('../resources/dashboard/Dashboard').default;
  return <Dashboard />;
};

export { DashboardWrapper };

export const noLayout = () => (
  <CustomRoutes noLayout>
    <Route
      path={`/${PublicRoutes.RECOVER}`}
      element={<PageLogin isRecover />}
    />
    <Route path={`/${PublicRoutes.RESET}`} element={<PageReset />} />
    <Route path="/app-selector" element={<AppSelector />} />
  </CustomRoutes>
);

export const customRoutes = () => (
  <CustomRoutes>
    <Route
      path="user-management"
      element={
        hasRole(['admin', 'gerente']) ? <UserManagement /> : <NonPermission />
      }
    />
  </CustomRoutes>
);
